export default {
  root: 'w-full border-b border-surface-200 dark:!border-gray-800',
};
